import $ from "jquery";

window.$ = window.jQuery = $;
globalThis.$ = $;
globalThis.jQuery = $;

export default $;
